import * as extensionTools from './extensionTools'

export const Ethereum = {
  extension: extensionTools,
}
